module.exports = {
  ScenariosData: () => {
    return [
      {
        "id": "studio",
        "name" : "Estudio",
        "icon": require('../assets/scenarios/icon-studio.png'),
        "iconselected": require('../assets/scenarios/icon-studio-white.png'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "city",
        "name" : "Ciudad",
        "icon": require('../assets/scenarios/icon-beach.png'),
        "iconselected": require('../assets/scenarios/icon-beach-white.png'),
        "interactable" : true,
        "active" : true,
      },
    ]
  }
}